// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "." + {"372":"85131143","677":"501c051c"}[chunkId] + ".chunk.js"; };